import React, { useState, useEffect, useContext, useRef } from "react";
import { useTranslation } from "react-i18next";

//Custom components
import { BaseLayerSwitcherControl } from "@/components/Map/Controls";
import mapService from "@/services/mapService";
import MapContext from "@/components/Map/MapContext";

//OL
import OlBaseLayer from "ol/layer/Base";
import OlVectorLayer from "ol/layer/Vector";
import OlVectorSource from "ol/source/Vector";
import OlLayerGroup from "ol/layer/Group";
import Collection from 'ol/Collection';

//Types
import { MapContextType } from "@/@types/context/MapContext";

type GeoBaseLayerSwitcherProps = {
  mapId: number;
  allowNoLayer?: boolean;
  isPublic?: boolean;
  isMini?: boolean;
}

function GeoBaseLayerSwitcher(props: GeoBaseLayerSwitcherProps) {
  const [baselayersGroup, setBaselayersGroup] = useState<OlLayerGroup | undefined>(undefined);
  const context: MapContextType | null = useContext(MapContext);
  const { t } = useTranslation();
  const { mapId, allowNoLayer, isPublic, isMini} = props;

  const mounted = useRef(false);

  useEffect(() => {
    mounted.current = true;

    return () => {
      mounted.current = false;
    }

  }, []);

  useEffect(() => {
    if (context?.map) {
      mapService.getBaseLayers(mapId, t).then((olGroup: OlLayerGroup)=> {
        var coll;
        if (olGroup) {
          if (allowNoLayer) {
            coll = olGroup.getLayers();
            const solidColorLayer = new OlVectorLayer({
              source: new OlVectorSource({}),
              // background: "#F00"
            })
            solidColorLayer.set("id", "base-solid");
            solidColorLayer.set("title", "N/A");
            solidColorLayer.set("type", "base");
            solidColorLayer.set("code", "no_layer")
            solidColorLayer.set("baseLayer", true);

            let parsedMapBaseLayers: { [key: number]: string } = {};

            try {
              const mapBaseLayers = localStorage.getItem("mapbaselayers");
              if (mapBaseLayers) {
                parsedMapBaseLayers = JSON.parse(mapBaseLayers);
              }
            } catch (error) {
              console.error("Error parsing mapbaselayers from localStorage:", error);
              // Fallback to an empty object if parsing fails
              parsedMapBaseLayers = {};
            }

            if (parsedMapBaseLayers[mapId] === "no_layer") {
              solidColorLayer.setVisible(true);
            } else {
              solidColorLayer.setVisible(false);
            }

            coll.insertAt(0, solidColorLayer);
            olGroup.setLayers(coll);
          }
          const mapLayers = context?.map?.getLayers();
          if (mapLayers) {
            mapLayers.remove(olGroup)
            mapLayers.insertAt(0, olGroup);
          }
        }

        if (mounted.current) {
          setBaselayersGroup(olGroup);
        }
      });
    }
  }, [context?.map]);

  const showBaseLayerSwitcher =
    context?.map &&
    baselayersGroup && baselayersGroup.getLayers && baselayersGroup.getLayers().getArray().length > 0 ? true : false;

  const layersArray = baselayersGroup ? baselayersGroup.getLayers().getArray() : [];

  return showBaseLayerSwitcher ? (
    <BaseLayerSwitcherControl isPublic={isPublic} layers={layersArray} isMini={isMini} mapId={mapId}/>
  ) : null;
}

export default GeoBaseLayerSwitcher;
